module.exports = __webpack_public_path__ + "img/rep-active.419f968c.jpg";